<template>
  <div>
    <div v-if="section==1">
      <v-layout row>
        <v-flex xs12 sm8 offset-sm2 lg4 offset-lg4>
          <v-card>
            <progress-bar :show="form.busy"></progress-bar>
            <form @submit.prevent="reset" @keydown="form.onKeydown($event)">
              <v-card-title primary-title>
                <h3 class="headline mb-0">{{ $t('reset_password') }}</h3>
              </v-card-title>
              <v-card-text>

                <!-- Password -->
                <password-input
                  :form="form"
                  :hint="$t('password_length_hint')"
                  :v-errors="errors"
                  :value.sync="form.password"
                  v-on:eye="eye = $event"
                  name="password"
                  ref="password"
                  v-validate="'required|min:8'"
                ></password-input>

                <!-- Password Confirmation -->
                <password-input
                  :form="form"
                  :hide="eye"
                  :label="$t('confirm_password')"
                  :v-errors="errors"
                  :value.sync="form.password_confirmation"
                  data-vv-as="password"
                  hide-icon="true"
                  name="password_confirmation"
                  v-validate="'required|confirmed:password'"
                ></password-input>
                
              </v-card-text>
              <v-card-actions>
                <submit-button :flat="true" :form="form" :label="$t('reset_password')"></submit-button>
              </v-card-actions>
            </form>
          </v-card>
        </v-flex>
      </v-layout>
    </div>
    <div v-if="section==99">
      <v-container grid-list-xl text-xs-center>
        <v-layout row wrap>
          <v-flex xs10 offset-xs1>
            <v-alert
              :value="true"
              type="error"
            >
              This link is no longer valid. Please contact us if you have questions.
            </v-alert>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
  </div>
</template>

<script>
import Form from 'vform'
import axios from 'axios'
export default {
  name: 'reset-view',
  
  metaInfo () {
    return { title: this.$t('reset_password') }
  },
  
  data: () => ({
    form: new Form({
      token: '',
      password: '',
      password_confirmation: ''
    }),
    eye: true,
    section: 0,
  }),

  mounted() {
    this.busy = true
    this.form.token = this.$route.params.token
    axios.get(process.env.API_URL+'/password_reset_tokencheck/' + this.form.token)
    .then((response) => {
      if(response.data.token_check){
        this.section=1
      } else {
        this.section=99
      }
    })
    .catch((error) => {
      this.section=99
    })
    this.busy = false
  },

  methods: {
    async reset () {
      if (await this.formHasErrors()) return

      this.form.token = this.$route.params.token

      const response = await this.form.post(process.env.API_URL+'/password_reset')

      this.$store.dispatch('responseMessage', {
        type: 'success',
        text: this.$t('password_updated')
      })

      // Redirect home.
      this.$router.push({ name: 'bookings' })
    }
  }
}
</script>



// WEBPACK FOOTER //
// reset.vue?2ab337e8